<template>
  <div class="header-topbar">
    <ContainerInner class="header-topbar__inner">
      <div class="header-topbar__container">
        <TheHeaderTopbarButton icon-left="computer" :url="publicSite.url" :text="publicSite.text" />
        <TheHeaderTopbarButton icon-left="circle-user" :route="mySpace.url" :text="mySpace.text" v-if="isMobile" />
        <TheHeaderTopbarButton
          icon-left="circle-question"
          :text="help.text"
          :url="help.url"
          @click.native="openModal"
        />
      </div>
      <div class="header-topbar__container">
        <TheHeaderTopbarButton icon-left="tools" :url="dashboard.url" :text="dashboard.text" v-if="dashboard && dashboard.url" />
        <TheHeaderTopbarSearch class="header-topbar__search" />
        <TheHeaderTopbarProfile class="header-topbar__profile" />
      </div>
    </ContainerInner>
  </div>
</template>

<script>
import ContainerInner from '@containers/ContainerInner'
import TheHeaderTopbarButton from './TheHeaderTopbarButton'
import TheHeaderTopbarProfile from './TheHeaderTopbarProfile'
import TheHeaderTopbarSearch from './TheHeaderTopbarSearch'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TheHeaderTopbar',

  data () {
    return {
      modalType: 'help'
    }
  },
  components: {
    ContainerInner,
    TheHeaderTopbarButton,
    TheHeaderTopbarProfile,
    TheHeaderTopbarSearch
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice',
      publicSite: 'header/getPublicSite',
      help: 'header/getHelp',
      mySpace: 'header/getMySpace',
      dashboard: 'header/getDashboard'
    }),
    isMobile () {
      return this.device !== 'desktop'
    }
  },
  methods: {
    ...mapActions({
      updateName: 'modal/updateName'
    }),
    openModal () {
      this.updateName(this.modalType)
    }
  }
}
</script>

<style lang="scss">
  .header-topbar{
    @include media("small-medium"){}
    @include media("large"){}

    display: flex;
    background-color: colors("topbar");
    width: 100%;

    > *{
      flex: 0 1 auto;
    }

    // Inner

    &__inner{
      @include media("small-medium"){
        flex-direction: column;
        padding: 0;
      }
      @include media("large"){
        flex-direction: row;
        justify-content: space-between;
      }

      width: 100%;
      display: flex;

      > *{
        flex: 0 1 auto;
      }
    }

    &__container{
      @include media("large"){
        display: flex;
        flex-direction: row;
        // justify-content: space-between;
      }
      flex: 0 1 auto;
    }

    // Profile

    &__profile{
      @include media("small-medium"){
        width: 100%;
        order: -1;
      }

      // margin-left: auto;
    }

    &__search{
      margin-left: auto;
      margin-right: 0;
    }
  }

</style>
